var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row flex-wrap"},_vm._l((_vm.data),function(course,index){return _c('CourseItem',{key:index,staticClass:"cor",class:{ isRight: (index + 1) % 4 === 0 },attrs:{"data":course}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }